export default __webpack_public_path__ + "static/media/dfa-auth-bottom.22384fb3.svg";